"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ApiInjector_1 = __importDefault(require("../lib/ApiInjector"));
const VoxeetApi_1 = __importDefault(require("./VoxeetApi"));
class TelemetryApi {
    static getHost() {
        return TelemetryApi.host;
    }
}
TelemetryApi.host = __TELEMETRY_HOST__;
/**
 * @ignore
 */
TelemetryApi.endpoints = {
    configuration: {
        fetch: { method: 'GET', uri: '/api/v1/metrics/configuration' },
    },
    webrtc: {
        sendBatch: { method: 'POST', uri: '/api/v1/metrics/webrtc/conferences/{conferenceId}/users/{userId}' },
    },
    dvc: {
        sendBatch: { method: 'PUT', uri: '/api/v1/metrics/dvc/conferences/{conferenceId}/users/{userId}/timestamp/{timestamp}' },
    },
    device: {
        send: { method: 'PUT', uri: '/api/v1/metrics/device/users/{userId}/timestamp/{timestamp}' },
    },
};
ApiInjector_1.default.inject(TelemetryApi, VoxeetApi_1.default.getToken, VoxeetApi_1.default.setToken, VoxeetApi_1.default.getJwtToken, VoxeetApi_1.default.getTokenCallback, () => { }, TelemetryApi.getHost, TelemetryApi.endpoints, true, VoxeetApi_1.default.isTokenExpired, VoxeetApi_1.default.getLeavingCallback);
exports.default = TelemetryApi;
